module.exports = __webpack_public_path__ + "ptc_nakagawa_G1.385d1b54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_G1.jpg
// module id = PBhZ
// module chunks = 0